import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const Features = () => {
  const { t } = useLanguage();

  const features = [
    { icon: "Layout", title: t("features.items.dashboard.title"), desc: t("features.items.dashboard.desc") },
    { icon: "Ticket", title: t("features.items.ticketing.title"), desc: t("features.items.ticketing.desc") },
    { icon: "MessageSquare", title: t("features.items.ai.title"), desc: t("features.items.ai.desc") },
    { icon: "Percent", title: t("features.items.options.title"), desc: t("features.items.options.desc") },
    { icon: "Code", title: t("features.items.widget.title"), desc: t("features.items.widget.desc") },
    { icon: "Activity", title: t("features.items.insights.title"), desc: t("features.items.insights.desc") }
  ];

  const containerVariants = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.1 } } };
  const itemVariants = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.5 } } };

  return (
    <section id="features" className="py-24 relative overflow-hidden">
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-indigo-100/20 blur-[100px] -z-10" />
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-3 py-1 rounded-full bg-indigo-50/50 backdrop-blur-sm border border-indigo-100 text-indigo-700 text-xs font-semibold uppercase tracking-wider mb-4 shadow-sm">
            {t('features.badge')}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 tracking-tight">
            {t('features.title')}
          </h2>
          <p className="text-lg text-slate-600">
            {t('features.subtitle')}
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, idx) => (
            <motion.div key={idx} variants={itemVariants} className="glass-card p-8 rounded-3xl inner-glow group">
              <div className="w-12 h-12 bg-white/50 backdrop-blur-sm border border-white/50 rounded-2xl flex items-center justify-center mb-6 text-indigo-600 shadow-sm group-hover:bg-indigo-600 group-hover:text-white transition-all duration-500">
                <SafeIcon name={feature.icon} className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{feature.title}</h3>
              <p className="text-slate-600 leading-relaxed text-sm">
                {feature.desc}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;